import { useRef, useState, useEffect } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import Image from 'next/image';
import Audio2Icon from '../../../public/icons/audioGradient';
import { saveAs } from 'file-saver';
import { cdn_url } from '@/utils';
import { use } from 'chai';
import { setSourceMapsEnabled } from 'process';
export const AudioPlayer = ({ showDownload, audioplaying, audioData, name, handleDeleteMedia, hideDelete }: any) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);

  const [src, setSrc] = useState<string>('');


const handleDownload = () => {
  if (audioData?.preview.startsWith('blob:')) {
    fetch(audioData)
      .then(res => res.blob())
      .then(blob => {
        saveAs(blob, name || 'audio.m4a');
      })
      .catch(err => {
        console.error('Download failed:', err);
      });
  } else if(!audioData?.preview && audioData?.fileName) {
    // for absolute or base64 URLs
    saveAs(src, name || 'audio.m4a');
  }
};


useEffect(() => {
  if (audioData?.preview) {
    setSrc(audioData.preview);
  }
  else if( audioData?.fileName) {
    setSrc(`${cdn_url}${audioData.fileName}`);
  }
  else{
    setSrc(audioData);
  }
}, [audioData]);

  const handleTogglePlay = () => {
    if (audioRef.current) {
      if (playing) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setPlaying(!playing);
    }
  };

  const handleAudioEnd = () => {
    setPlaying(false);
  };

  useEffect(() => {
    if (audioRef.current) {
      setPlaying(false);
      audioRef.current.pause();
    }
  }, [audioplaying]);

  return (
    <Box
      sx={{
        width: '350px',
        height: '120px',
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: 'rgba(255, 255, 255, 0.82)',
        display: 'flex',
        flexDirection: 'column',
        padding: '10px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        marginBottom: '10px',
        position: 'relative',
      }}>
      {/* Delete Button */}
      {!hideDelete && (
        <IconButton onClick={handleDeleteMedia} sx={{ position: 'absolute', top: 5, right: 5, background: '#D8E8F6' }}>
          <Image priority src={'/icons/delete-black.svg'} alt={'delete'} width={15} height={15} />
        </IconButton>
      )}
      {showDownload && (
        <Box sx={{ position: 'absolute', top: 40, right: 5 }}>
          <IconButton onClick={handleDownload} sx={{ background: '#D8E8F6' }}>
            <Image priority src='/icons/download.svg' alt='download' width={15} height={15} />
          </IconButton>
        </Box>
      )}

      {/* Play Button & Icon */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexGrow: 1 }}>
        <IconButton onClick={handleTogglePlay}>
          <Image
            priority
            src={playing ? '/icons/pause.svg' : '/icons/playbut-blue.svg'}
            alt={'play button'}
            width={35}
            height={35}
          />
        </IconButton>
        <Audio2Icon color={'rgba(1, 113, 206, 1)'} color2={'rgba(62, 68, 194, 1)'} />
      </Box>

      {/* Hidden Audio Element */}
      <audio ref={audioRef} src={src} onEnded={handleAudioEnd} />

      {/* Title */}
      <Typography sx={{ marginLeft: '12px', fontSize: '16px', color: '#000', textAlign: 'start' }}>
        {name ? name.replace(/^\d+_/, '').trim() : 'hello'}
      </Typography>
    </Box>
  );
};

export default AudioPlayer;